import { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'destructive';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export function BigCTA({ variant = 'primary', className, ...rest }: Props) {
  const cls = ['big-cta'];
  if (variant !== 'primary') cls.push(variant);
  if (className) cls.push(className);
  return <button {...rest} className={cls.join(' ')} />;
}
